export enum ErrorType {
    Minimum = "minimum",
    Maximum = "maximum",
    None = "none",
}
